/* stats/actions */
import { action } from "typesafe-actions";
import { Stats, StatsActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(StatsActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: Stats) =>
  action(StatsActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(StatsActionTypes.FETCH_ERROR, error);
